import { Component, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { CodeTable, CT } from "@shared/services/code-table/code-table.model";
import { CodeTableService } from "@shared/services/code-table/code-table.service";
import { DealerService } from "@shared/services/dealers/dealer.service";
import { SnackbarService } from "@shared/services/snackbar.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { forkJoin, take } from "rxjs";

@Component({
	selector: "app-private-contact",
	templateUrl: "./private-contact.component.html",
	styleUrl: "./private-contact.component.scss",
	standalone: false
})
export class PrivateContactComponent {
	localizedCountry: any;
	private codeTableService = inject(CodeTableService);
	private userService = inject(UsersService);
	private userApiService = inject(UserApiService);
	private snackBarService = inject(SnackbarService);
	protected wcmService = inject(WcmService);

	private dealerService = inject(DealerService);
	private fb = inject(FormBuilder);
	protected dataSent = false;

	protected claimTypes: CodeTable[] = []
	protected files: File[] = [];

	contactForm = this.fb.nonNullable.group({
		businessName: [{ value: '', disabled: true }],
		city: [{ value: '', disabled: true }],
		name: [{ value: '', disabled: true }],
		checkConsents: [false, Validators.requiredTrue],
		// To be sent
		email: ['', [Validators.required, Validators.email]],
		phone: ['', Validators.required],
		claimType: ['', Validators.required],
		licensePlate: ['', Validators.required],
		message: ['', Validators.required],
	});
	protected deleteAttachment(index: number) {
		this.files.splice(index, 1);
	}

	fileChanged(files: FileList) {
		const newFiles = Array.from(files);
		if (this.files.length) {
			for (const newFile of newFiles) {
				const i = this.files.findIndex(f => f.name === newFile.name);
				if (i !== -1) {
					this.deleteAttachment(i); // Removing previous file with the same name
				}
			}
		}

		this.files = this.files.concat(newFiles);
	}

	constructor() {
		this.userService.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(u => {
				forkJoin({
					dealer: this.dealerService.getDealerInfoUsingGET(u.idDealer),
					claimTypes: this.codeTableService
						.getCTElementsUsingGET(
							CT[CT.CLAIM_TYPE],
							u.idMarket
						)
				}).pipe(take(1))
					.subscribe({
						next: ({ dealer, claimTypes }) => {
							this.claimTypes = claimTypes;
							this.contactForm.controls.businessName.setValue(dealer.businessName || "");
							this.contactForm.controls.city.setValue(dealer.city || "");
							this.contactForm.controls.email.setValue(dealer.email || "");
							this.contactForm.controls.phone.setValue(dealer.mobile || "");
							this.contactForm.controls.name.setValue(`${u.name} ${u.surname}`)
						}
					});
			});
	}
	protected onSubmit = () => {
		if (this.contactForm.valid) {
			this.dataSent = true;
			const { email,
				phone,
				claimType,
				licensePlate,
				message } = this.contactForm.value;
			this.userApiService.claim({
				email,
				phone,
				claimType,
				licensePlate,
				message,
			},
				this.files
			)
				.subscribe({
					next: () => {
						this.snackBarService.show({
							titlePlaceholder: "dialog.success.message",
							// messagePlaceholder: "dialog.success.title"
						});
					}, error: () => {
						this.snackBarService.show({
							status: "error",
							titlePlaceholder: "dialog.error"/*,
							messagePlaceholder: "dialog.success.title" */
						});
						this.dataSent = false;
					}
				});
		}
	}
}